import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    Authorization: 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
  }
})

export { axiosInstance };